import React, { useEffect, useState } from "react";
import '../Assets/css/login.css'
import getData from "../Custome_Components/commonAPISelect";
import getData2 from "../Custome_Components/commonAPISelect2";
import userIcon from "../Assets/img/userIcon.png";
import passwordIcon from "../Assets/img/passwordIcon.png";
import hideIcon from "../Assets/img/hide.png";
import showIcon from "../Assets/img/show.png";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import loginSlide1 from "../Assets/img/loginSlide1.jpg";
import loginSlide2 from "../Assets/img/loginSlide2.jpg";
import loginSlide3 from "../Assets/img/loginSlide3.jpg";
import SupportPortal from '../Assets/img/SupportPortal.png';
import SmartFM from '../Assets/img/Smartfm.png';
import Nanosoft from '../Assets/img/Nanosoft.png';
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";

function Login() {

    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => { localStorage.setItem("EmpID", '') }, [])

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!username) {
            toast.warning("Kindly Enter User Name");
            return;
        }
        if (!password) {
            toast.warning("Kindly Enter User Password");
            return;
        }

        try {
            const response = await getData2("DashboardService/VwAPINSEIPLDetailsNew/", {
                data: {
                    p1_int: 116,
                    P9_varchar: username ?? null,
                    P10_varchar: password ?? null
                },
            });

            const { Output } = response;
            const { status, data } = Output;

            if (status.code == "200") {
                if (!data || data.length === 0) {
                    toast.error("Invalid Username / Password");
                    return;
                }

                const userValues = data[0];
                if (!userValues) {
                    toast.error("Invalid Username / Password");
                    return;
                }

                const EmpID = userValues?.EmployeeID;
                const EmpName = userValues?.EmpName || "";
                const UserIDPK = userValues?.UserIDPK;

                if (!UserIDPK) {
                    toast.error("Invalid Username / Password");
                    return;
                }

                localStorage.setItem("UserName", EmpName);
                localStorage.setItem("EmpID", EmpID);

                toast.success("Login Successfully");
                navigate("/dashboard");
            } else {
                toast.error(status.message || "Login failed. Please try again.");
            }
        } catch (error) {
            console.error("Error during login:", error);
            toast.error("An error occurred. Please try again.");
        }
    };

    return (
        <div className="LoginPageParent">
            <div className="LoginPageSubParent">

                <div className="LoginImageCardParent">
                    <Carousel className="LogingCarouselParent"
                        showThumbs={false}
                        showStatus={false}
                        infiniteLoop={true}
                        autoPlay={true}
                        interval={2000}
                        stopOnHover={true}
                        showArrows={false}
                        swipeable={true}
                        dynamicHeight={false}
                        showIndicators={true}
                    >
                        <div className="LoginCarouselSlide">
                            <img src={loginSlide1} alt="Slide1" className="LoginSlideImageStyle" />
                        </div>
                        <div className="LoginCarouselSlide">
                            <img src={loginSlide2} alt="Slide2" className="LoginSlideImageStyle" />
                        </div>
                        <div className="LoginCarouselSlide">
                            <img src={loginSlide3} alt="Slide3" className="LoginSlideImageStyle" />
                        </div>
                    </Carousel>
                </div>

                <div className="LoginSectionCardParent">
                    <div className="SupportPortailParent">
                        <img src={SupportPortal} alt="SupportPortail" style={{ width: "170px" }} />
                    </div>
                    <div className="FormParentDiv">
                        <form className="LoginFieldsParent" onSubmit={handleLogin}>
                            <div className="WelcomeContentDiv">
                                <p className="LoginTextSty">Welcome</p>
                                <p className="LoginTextSty2">Please sign into your account</p>
                            </div>

                            <div className="LoginInputParentSec">
                                <div className="InputContainer">
                                    <span className="UserIcon"><img src={userIcon} className="UserNamePNG" alt="icon" /></span>
                                    <input type="text"
                                        placeholder="Enter username"
                                        className="UserNameInput"
                                        value={username}
                                        onChange={(e) => setUsername(e.target.value)}
                                    />
                                </div>

                                <div className="InputContainer">
                                    <span className="UserIcon"><img src={passwordIcon} className="UserNamePNG" alt="icon" /></span>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Enter password"
                                        className="PasswordInput"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <span className="PasswordIcon" onClick={togglePasswordVisibility}>
                                        {showPassword ?
                                            <img src={showIcon} className="UserNamePNG" alt="icon" /> :
                                            <img src={hideIcon} className="UserNamePNG" alt="icon" />
                                        }
                                    </span>
                                </div>
                            </div>

                            <div className="LoginBtnDiv">
                                <button type="submit" className="LoginButton"> Login </button>
                            </div>
                        </form>
                    </div>
                    <div className="LoginFooterParent">
                        <img src={SmartFM} alt="SmartFm" style={{ width: "170px" }} />
                        <img src={Nanosoft} alt="nanosoft" style={{ width: "120px" }} />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Login;
